import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion"; // ✅ Import Framer Motion
import NavbarAdmin from "../../Components/Admin/NavbarAdmin";
import Sidebar from "../../Components/Admin/Sidebar";
import backgroundImage from "../../Assets/background10.png";

const AdminHomepage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <PageContainer>
      <NavbarAdmin setIsSidebarOpen={setIsSidebarOpen} />
      <Container>
        <Sidebar isOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        <Content $isSidebarOpen={isSidebarOpen}>
          <HeroContent
            as={motion.div} // ✅ Make this a motion component
            initial={{ opacity: 0, y: 50 }} // Start hidden and 50px lower
            animate={{ opacity: 1, y: 0 }} // Fade in and move up
            transition={{ duration: 1, ease: "easeOut" }} // Smooth transition
          >
            <HeroText>Welcome, Administrator!</HeroText>
          </HeroContent>
        </Content>
      </Container>
    </PageContainer>
  );
};

export default AdminHomepage;

// ✅ Styled Components
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden; /* Prevent scrolling */
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed; /* Keeps the image fixed */
`;



const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  padding: 20px;
  width: 100%;
  transition: margin-left 0.3s ease-in-out;
  margin-left: ${({ $isSidebarOpen }) => ($isSidebarOpen ? "200px" : "50px")};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const HeroContent = styled.div`
  position: absolute;
  text-align: center;
  color: #fff;
  font-size: 48px;
  font-weight: bold;
  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.7);
  z-index: 2;
`;

const HeroText = styled.h1`
  top: 70px;
  font-size: 70px;
  color: #fff;
  font-weight: bold;
  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.7);
`;
